import {Dayjs} from 'dayjs';
import {IMediaTrack} from './MediaTrack.dto';
import {IUserBase} from './User.dto';
export enum RequestType {
  GAMETIME_DEMO = 1,
  GT_TITLE_SPONSOR_DEMO = 2,
  NEPTUNE_RADIO_DEMO = 3,
  SCHOOLZONE_DEMO = 4,
  TNN_DEMO = 5,
}

export const RequestTypeNames: Record<RequestType, string> = {
  [RequestType.GAMETIME_DEMO]: 'GameTime Demo',
  [RequestType.GT_TITLE_SPONSOR_DEMO]: 'GT Title Sponsor Demo',
  [RequestType.NEPTUNE_RADIO_DEMO]: 'Neptune Radio Demo',
  [RequestType.SCHOOLZONE_DEMO]: 'SchoolZone Demo',
  [RequestType.TNN_DEMO]: 'TNN Demo',
};

export interface IDemoStingerCreateProps {
  category: string;
  name: string;
  mascot: string;
  option: number;
  date: Dayjs | null;
  note: string;
  category_option: string;
  station_name: string;
  prospect: string;
  partner_id: number;
  product_rep_id: number;
  product_rep: string;
  advertiser?: string;
  advertiser_url?: string;
}

export interface IDemoStingerValues {
  id: number;
  request_id: number;
  request_type: RequestType;
  category: number;
  name: string;
  mascot: string;
  option: number;
  date: string;
  note: string;
  category_option: string;
  task_slug?: string;
  user?: IUserBase;
  status: string;
  file_url: string;
  file_name: string;
  station_name: string;
  prospect_partner: string;
  media_track: IMediaTrack;
  advertiser?: string;
  advertiser_url?: string;
  school_name_pronunciation?: string;
  mascot_pronunciation?: string;
}
export interface IDemoStingerDefaultProps {
  id: number;
  product: string;
  script: string;
  type: string;
}
export interface IDemoStingerMessageProps {
  id: number;
  name: string;
  message: string;
  file_url?: string;
  file_name?: string;
}
export interface IDemoStingerResponseProp {
  values: IDemoStingerValues;
  default_stingers: IDemoStingerDefaultProps[];
  messages: IDemoStingerMessageProps[];
  adScript: IDemoStingerMessageProps[];
  partnerStinger: IDemoStingerMessageProps[];
}
export interface IDemoScriptStateProp {
  id: number;
  name: string;
  message?: string;
  file?: File | null;
  file_url?: string;
  file_name?: string;
}
export interface IDemoResponse {
  id: number;
  name: string;
  option: string;
  date: string;
  created_by: string;
  status: string;
  file_url: string;
  note?: string;
  advertiser?: string;
  advertiser_url?: string;
  mascot?: string;
  media_track?: IMediaTrack | null;
}
export const LabelName: {[key: string]: string} = {
  [RequestType.GAMETIME_DEMO]: 'School/District Name',
  [RequestType.GT_TITLE_SPONSOR_DEMO]: 'Target Sponsor Name',
  [RequestType.NEPTUNE_RADIO_DEMO]: 'Company/facility ',
  [RequestType.SCHOOLZONE_DEMO]: 'School Name',
  [RequestType.TNN_DEMO]: 'School/District Name',
};
export interface IDemoAdSpotProps {
  id: number;
  name: string;
  adspot: string;
  file: File[] | null;
}
export interface IDemoStringerProp {
  id: number;
  label: string;
  name: string;
  file: File | null;
}
